import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-medium, syntax, brackets, dev"} maskId="square-filled-radius-0-stroke-1-IconCodeMedium"><path fillRule="evenodd" clipRule="evenodd" d="M7.70328 7.50008L3.20328 12.0001L7.70328 16.5001L6.99617 17.2072L1.78906 12.0001L6.99617 6.79297L7.70328 7.50008ZM16.9962 6.79297L22.2033 12.0001L16.9962 17.2072L16.2891 16.5001L20.7891 12.0001L16.2891 7.50008L16.9962 6.79297Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCodeMedium;
